export default "__VITE_ASSET__CfVx$GX0__"